import { Navigate } from "react-router-dom"
import { useAuth } from "../context/AuthContext"

export default function ProtectedRoute({
    children,
}: {
    children: JSX.Element
}) {
    const { isAuthenticated, loading } = useAuth()

    if (loading) {
        return null;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />
    }

    return children
}
